import React from 'react';
import "./topheader.css";
import call from "../../assets/icons/call-answer-01.png";
import whatsapp from "../../assets/icons/whatspp-01.png"

function Topheader() {
  return (
    <>
      <div class="top-header-area">
        <div class="h-100 d-md-flex justify-content-between align-items-center">
          <div class="email-address">
            <a href="mailto:info@nspp.in">info@nspp.in</a>
          </div>
          <div class="phone-number d-flex">
            <div class="icon">
              <img src={call} alt="call" className="call-icon" />

            </div>
            <div class="number">
              <a href="tel:+919500707033">+91 9500707033</a>
            </div>
          </div>
        </div>
      </div>

      <section>

        <div className="main-icons">
          <ul className="first">
            <li className="color1">
              <a href="tel:+919500707033">
                <p>Call <br />+91 9500707033</p>
                <img src={call} width="20px" height="20px" className="img-fluid" />
              </a>
            </li>
            <li className="color2">
              <a href="https://api.whatsapp.com/send?phone=919500707033" target="_blank">
                <p>Whatsapp <br />+91 9500707033</p>
                <img src={whatsapp} width="24" height="24" className="img-fluid" />
              </a>
            </li>
            {/* <li className="color3">
                      <a
                        href="https://maps.app.goo.gl/W9jNi6VWGbfWmbB57"
                        target="_blank"
                        rel="noopener noreferrer" // Best practice for opening new tabs
                      >
                        <p style={{ color: "black" }}>Location <br />First Sky Infra</p>
                        <img src={map} width="30" height="30" className="img-fluid1" alt="Map Icon" />
                      </a>
                    </li> */}

          </ul>
        </div>
      </section>

    </>

  )
}

export default Topheader
